import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChangePhoneNumberComponent } from './change-phone-number/change-phone-number.component';
// import { CustomerEnrollWizardComponent } from './customer-enroll-wizard/customer-enroll-wizard.component';
import { CustomerEnrollWizardV2Component } from './customer-enroll-wizard-v2/customer-enroll-wizard-v2.component';
// import { FirstPaymentOptionComponent } from './first-payment-option/first-payment-option.component';
import { SetupAutopayComponent } from './setup-autopay/setup-autopay.component';
import { CongratsComponent } from './congrats/congrats.component'
import { EsiIdFlaggedComponent } from 'app/esiid-flagged/esiid-flagged.component';

const routes: Routes = [
  // { path: 'enrollment-wizard', component: CustomerEnrollWizardComponent},
  // { path: 'enrollment-wizard', component: CustomerEnrollWizardV2Component },
  { path: 'enrollment-wizard/esiid-flagged', component: EsiIdFlaggedComponent },
  { path: 'enrollment-wizard/:step', component: CustomerEnrollWizardV2Component },   
  { path: 'congrats', component: CongratsComponent },
  { path: 'setup-autopay', component: SetupAutopayComponent },
  { path: 'enrollment-wizard/change-phone-number/:username', component: ChangePhoneNumberComponent },
  { path: 'Profile/:account_setting/ChangePhoneNumber/:username', component: ChangePhoneNumberComponent },
  { path: ':internal-user/:account_setting/change-phone/:username', component: ChangePhoneNumberComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerEnrollRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/customer-enroll/customer-enroll-routing.module.ts